module.exports = __webpack_public_path__ + "static/media/thumbnails.3d1e96b9.png";